<div
  class="dashboard"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  fxLayoutGap="10px"
>
  <mat-card fxLayout="row" fxLayoutAlign="space-between center">
    <mat-card-content
      fxFlex
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <menu-header [menuTopic]="baseLineMenu"></menu-header>

      <!-- <h1 style="margin: 0;">{{ "view_value.group_baseline" | translate }}</h1> -->
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <a
          [routerLink]="['/group-baseline/history']"
          class="btn-outline"
          mat-stroked-button
        >
          <mat-icon> history_2 </mat-icon>
          {{ "view_value.baseline_history" | translate }}</a
        >
        <button
          class="btn-primary"
          mat-stroked-button
          (click)="create_baseline()"
        >
          <mat-icon> add </mat-icon>
          {{ "view_value.create_group_baseline" | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between strecth"
    fxLayoutGap="10px"
    style="min-height: 80vh"
  >
    <mat-card fxFlex="22" fxLayout="column" fxLayoutAlign="start stretch">
      <mat-card-header fxLayout="column" fxLayoutAlign="start stretch">
        <mat-card-title fxLayout="column" fxLayoutAlign="start stretch">
          <div
            fxFlex="80px"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="10px"
          >
            {{ "view_value.usage_ranking" | translate }}
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxFlex>
        <div
          echarts
          [options]="top_kwh_thismonth_options"
          style="height: 100%"
        ></div>
      </mat-card-content>
    </mat-card>
    <mat-card fxFlex fxLayout="column" fxLayoutAlign="start stretch">
      <mat-card-header fxLayout="column" fxLayoutAlign="start stretch">
        <mat-card-title fxLayout="column" fxLayoutAlign="start stretch">
          <div
            fxFlex="80px"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="10px"
          >
            <span style="white-space: nowrap">{{
              "view_value.baseline_overview" | translate
            }}</span>
            <div
              [formGroup]="form_baseline_graph"
              style="display: flex; gap: 10px; align-items: center"
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ "view_value.period" | translate }}</mat-label>

                <mat-select formControlName="period">
                  <mat-select-trigger>
                    {{
                      form_baseline_graph.get("period")?.value === "day"
                        ? ("view_value.day" | translate)
                        : ("view_value.month" | translate)
                    }}
                  </mat-select-trigger>

                  <mat-option value="day">{{
                    "view_value.day" | translate
                  }}</mat-option>
                  <mat-option value="month">{{
                    "view_value.month" | translate
                  }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                *ngIf="form_baseline_graph.get('period')?.value === 'day'"
              >
                <mat-label>{{ "view_value.day" | translate }}</mat-label>

                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="date"
                />

                <mat-datepicker-toggle matSuffix [for]="picker">
                </mat-datepicker-toggle>

                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <app-month-picker
                *ngIf="form_baseline_graph.get('period')?.value === 'month'"
                [value]="form_baseline_graph.get('month')?.value ?? null"
                (valueChange)="onMonthChange($event)"
              >
              </app-month-picker>
            </div>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content
        *ngIf="mockup"
        fxFlex
        fxLayout="column"
        fxLayoutAlign="start stretch"
        fxLayoutGap="10px"
      >
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2px">
          <div>
            {{ mockup?.detail?.baseline_group_name }}
          </div>
          <div *ngIf="form_baseline_graph.get('period')?.value === 'day'">
            {{ "view_value.overall_daily_energy" | translate }}
            {{ form_baseline_graph.get("date")?.value | date: "dd/MM/yyyy" }}
          </div>
          <div *ngIf="form_baseline_graph.get('period')?.value === 'month'">
            {{ "view_value.monthly_energy" | translate }}
            {{ mockup?.detail.top_data?.start_date | date: "MM/yyyy" }}
          </div>
          <div>
            {{ "view_value.total" | translate }}
            :
            {{ mockup?.detail?.top_data?.total_kwh_usage | number: "1.0-2" }}
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div>
              {{ "Min" | translate }} :
              {{ mockup?.detail.summary_data.min | number: "1.0-2" }}
            </div>
            <mat-divider vertical style="height: 100%"></mat-divider>
            <span
              >{{ "Max" | translate }} :
              {{ mockup?.detail.summary_data.max | number: "1.0-2" }}</span
            >
            <mat-divider vertical style="height: 100%"></mat-divider>
            <span
              >{{ "Avg" | translate }} :
              {{ mockup?.detail.summary_data.avg | number: "1.0-2" }}</span
            >
          </div>
        </div>

        <div
          echarts
          [options]="baseline_overview_chartOptions"
          style="height: 100%"
        ></div>
      </mat-card-content>
    </mat-card>
    <mat-card
      fxFlex="20"
      fxLayout="column"
      fxLayoutAlign="start stretch"
      fxLayoutGap="10px"
    >
      <mat-card-header fxLayout="column" fxLayoutAlign="start stretch">
        <mat-card-title fxLayout="column" fxLayoutAlign="start stretch">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="10px"
          >
            {{ "view_value.list_group_baseline" | translate }}
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="baseline-container">
        <div
          class="group-item"
          [class.group-item-selected]="
            form_baseline_graph.value.baseline_group_name === item.name
          "
          *ngFor="let item of baseline_group_list"
        >
          <div class="accent-bar"></div>

          <div class="item-body">
            <div class="baseline-info" (click)="selectBaseline(item)">
              <span class="baseline-name">{{ item.name }}</span>
              <div class="baseline-stats">
                <div class="stat">
                  <span class="stat-label">{{
                    "view_value.setpoint_day" | translate
                  }}</span>
                  <span class="stat-value">{{ item.setpoint_day }}</span>
                </div>
                <div class="stat">
                  <span class="stat-label">{{
                    "view_value.setpoint_month" | translate
                  }}</span>
                  <span class="stat-value">{{ item.setpoint_month }}</span>
                </div>
              </div>
            </div>

            <div class="action-buttons">
              <button
                mat-icon-button
                class="icon-primary-btn"
                [matMenuTriggerFor]="baselineMenu"
                (click)="$event.stopPropagation()"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #baselineMenu="matMenu">
                <button mat-menu-item (click)="update_baseline(item)">
                  <mat-icon>settings</mat-icon>
                  <span>{{ "view_value.edit" | translate }}</span>
                </button>

                <button mat-menu-item (click)="delete_baseline(item)">
                  <mat-icon>delete</mat-icon>
                  <span>{{ "view_value.delete" | translate }}</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
